import { render, staticRenderFns } from "./ForgotCode.vue?vue&type=template&id=c8e4a882&"
import script from "./ForgotCode.vue?vue&type=script&lang=js&"
export * from "./ForgotCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports